import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload, ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { api } from "../../lib/api";
import { errMsg } from "../../lib/insApi";
import axios from "axios";

const plusYear = (d) => { if (!d) return ""; const x = new Date(d); x.setFullYear(x.getFullYear() + 1); x.setDate(x.getDate() - 1); return x.toISOString().slice(0, 10); };

export const VehicleInsuranceDialog = ({ vehicle, onClose, onSaved }) => {
  const [f, setF] = useState({ start_date: vehicle?.start_date || "", expiry_date: vehicle?.expiry_date || "", policy_number: vehicle?.policy_number || "" });
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const att = file ? await api.uploadFile(file) : {};
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/insurance/vehicle`, {
        vehicle_number: vehicle.vehicle_number, ...f,
        attachment_id: att.attachment_id || (file ? "" : vehicle.own_policy ? vehicle.attachment_id || "" : ""),
        attachment_name: att.attachment_name || (file ? "" : vehicle.own_policy ? vehicle.attachment_name || "" : ""),
      });
      toast.success(`تم حفظ تأمين السيارة ${vehicle.vehicle_number}`);
      onSaved();
    } catch (e) { toast.error(errMsg(e, "تعذّر الحفظ")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!vehicle} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="max-w-md font-body" data-testid="vehicle-ins-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 text-right font-heading"><ShieldCheck className="h-5 w-5 text-teal-600" /> تأمين السيارة <span dir="ltr">{vehicle?.vehicle_number}</span></DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-2">
            <label className="space-y-1 text-xs text-slate-500">تاريخ السريان
              <Input data-testid="vehicle-ins-start" type="date" value={f.start_date} onChange={(e) => setF((p) => ({ ...p, start_date: e.target.value, expiry_date: p.expiry_date || plusYear(e.target.value) }))} /></label>
            <label className="space-y-1 text-xs text-slate-500">تاريخ الانتهاء
              <Input data-testid="vehicle-ins-expiry" type="date" value={f.expiry_date} onChange={(e) => setF((p) => ({ ...p, expiry_date: e.target.value }))} /></label>
          </div>
          <Input data-testid="vehicle-ins-policy" placeholder="رقم البوليصة (اختياري)" value={f.policy_number} onChange={(e) => setF((p) => ({ ...p, policy_number: e.target.value }))} />
          <label className="flex cursor-pointer items-center gap-2 rounded-lg border border-dashed border-teal-300 px-3 py-2 text-sm text-slate-600" data-testid="vehicle-ins-file-label">
            <Upload className="h-4 w-4 text-teal-600" /> {file ? file.name : vehicle?.own_policy && vehicle?.attachment_id ? "استبدال ملف البوليصة" : "إرفاق ملف البوليصة (PDF أو صورة)"}
            <input data-testid="vehicle-ins-file" type="file" accept="application/pdf,image/*" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </label>
          <p className="text-xs text-slate-500">التأمين يُحفظ على السيارة نفسها، ويبقى معها حتى لو تغيّر السائق.</p>
          <Button data-testid="vehicle-ins-save" disabled={!f.expiry_date || busy} onClick={save} className="w-full gap-1.5 bg-teal-600 hover:bg-teal-700">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} حفظ التأمين</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
